import { Pipe, PipeTransform } from '@angular/core';
import { CardType } from '../../menu-cards/card-type.enum';
import { ComboCard } from '../../../../../../../../models/menu/product-menu-cards/combo-card';
import { Card } from '../../../../../../../../models/menu/product-menu-cards/card';

@Pipe({
  name: 'isFullImageCard',
  standalone: false
})
export class IsFullImageCardPipe implements PipeTransform {
  transform(value: Card): boolean {
    return value instanceof ComboCard ? value?.type === CardType.Full : false;
  }
}
